

<template>
 <div>
  <div class="other-foot-icon">
    <a href="javascript:;" @click="detailShare('weixin')"><img src="@/assets/images/s1.png" /></a>
    <a href="javascript:;" @click="detailShare('whats')"><img src="@/assets/images/s3.png" /></a>
    <a href="javascript:;" @click="detailShare('facebook')"><img src="@/assets/images/foot1.png" /></a>
    <a href="javascript:;" @click="detailShare('twitter')"><img src="@/assets/images/s2.png" /></a>
  </div>
 
  <el-dialog
  title="share"
  :visible.sync="show"
  width="200px"
  center>
  <vue-qrcode
  :value="images"
  :options="{ size: 150, foreground: '#333' }"
></vue-qrcode>
</el-dialog>
 </div>
</template>
<style  scoped="scoped">
  .popCuponBox .popCupon{ width: 450px;}
</style>

<script>
  import { Dialog } from 'vant';
  
import VueQrcode from "@xkeshi/vue-qrcode";
export default {
  name: "share",
  data() {
    return {
      show:false,
      images:''
    };
  },
  components: {
    VueQrcode
  },
  created() {},
  mounted(){
    this.images=window.location.href;
  },
  methods: {
    detailShare(app){
        let url=window.location.href;
				let title=document.title;
				this.share(app,url,title)
    },
    share(app,url,tit){
      /**
                * 分享方法  
                * @param  { String } app 要分享的网站
                * @param  { String } url 分享的页面链接
                * @param  { String } tit 文字描述
            **/
            if(app=='facebook'){
                window.open(` https://www.facebook.com/sharer.php?u=${url}&t=${tit}`,"_blank","top=300,left=300,width=800,height=500,menubar=no,toolbar=no,status=no,scrollbars=no")
                return
            }
            if(app=='twitter'){
                window.open(` https://twitter.com/share?url=${url}&text=${tit}`,"_blank","top=200,left=200,width=500,height=500,menubar=no,toolbar=no,status=no,scrollbars=no")
                return
            }
            if(app=='weixin'){
               this.show=true;
            }
            if(app=='whats'){
                // window.open(` https://twitter.com/share?url=${url}&text=${tit}`,"_blank","top=200,left=200,width=500,height=500,menubar=no,toolbar=no,status=no,scrollbars=no")
                console.log(app);
                location="whatsapp://send?text="+ encodeURIComponent(url) + encodeURIComponent("\n\n"+tit)+"&via=lopscoop";
                return
            }
    }
  }
};
</script>





// WEBPACK FOOTER //
// src/components/global/share/index.vue